export default __webpack_public_path__ + "static/media/logomark.0353158c.svg";